var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-touch', {
    ref: "touch",
    on: {
      "singletap": _vm.tapToggleReadMode,
      "doubletap": _vm.zoomToggle,
      "panstart": _vm.handlePan,
      "panmove": _vm.handlePan,
      "panend": function panend($event) {
        return _vm.handlePan($event, true);
      },
      "pinchstart": _vm.handlePinch,
      "pinchmove": _vm.handlePinch,
      "pinchend": function pinchend($event) {
        return _vm.handlePinch($event, true);
      },
      "swipeleft": _vm.handleSwipe,
      "swiperight": _vm.handleSwipe
    }
  }, [_c('div', {
    style: _vm.style,
    on: {
      "wheel": _vm.handleWheel,
      "pointerdown": _vm.pointerDown,
      "pointerup": _vm.pointerUp
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }